var map = {
	"./happybet/components/personalAreaModal/PersonalAreaModal": [
		60792,
		2418,
		8857,
		792
	],
	"./snai/components/personalAreaModal/PersonalAreaModal": [
		11972,
		2418,
		8857,
		7816,
		9206,
		654,
		5827,
		9203,
		6830
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4140;
module.exports = webpackAsyncContext;